// extracted by mini-css-extract-plugin
export default {"caption":"TxtDyTqCEKGsAMM58IKo"};